import { BOT_NAME } from './Bot';

export const MODULE_USAGE_DESCRIPTION = {
  OVERVIEW: `Track monthly interactions with ${BOT_NAME} and the groups it integrates with. Usage charts highlight trends and engagement levels.`,

  MEMORY: `Store memory snippets that ${BOT_NAME} automatically recalls during conversations.`,

  SPACES: `Admins manage ${BOT_NAME}'s presence in Google Workspaces, enabling or disabling activity to suit the team.`,

  ORGANIZATIONS: `Set your active organization (/teams) so ${BOT_NAME} responds with data from that context in Google Chat.`,

  REPORT_GROUPS_DESCRIPTION:
    'Create message buckets called report groups to organize updates. Names must be snake_case, e.g., daily_tech_standup.',

  USERS: `Manage organization members: adjust roles, control ${BOT_NAME} access, and remove users when needed.`,

  SAVED_PROMPTS: `Save prompts for repeated tasks—like analyzing resumes or generating email replies—that anyone on your team can reuse.`,

  SETTINGS: `Update organization details, manage billing, or deactivate the organization in one place.`,

  HELP: `Watch video guides to integrate and use ${BOT_NAME}, improve productivity, and manage commands.`,

  REPORT_MESSAGES:
    'Summarize incidents or feedback in report groups. Messages can be edited for 30 minutes; only admins may delete them.',

  CONNECTORS: `Discover connectors that expand ${BOT_NAME}'s capabilities.`,

  TASKS:
    'Organize and track your work with kanban-style boards. Whatever tasks Hana performs, or tasks done by others that Hana knows about, appear here. This module complements existing project management tools, and we continue improving it with more built-in features. Tasks here are internal to Hana and are not synced with Google Tasks.',

  CONFLUENCE_CONNECTOR: `Read documentation on how to connect Confluence to ${BOT_NAME}.`,

  JIRA_CONNECTOR: `Read documentation on how to connect Jira to ${BOT_NAME}.`,

  NOTION_CONNECTOR: `Read documentation on how to connect Notion to ${BOT_NAME}.`,

  FILE_PICKER: `Select the files from your drive that you want ${BOT_NAME} to get access to.`,

  GET_STARTED: `Complete onboarding steps to set up your workspace and get the most out of ${BOT_NAME}.`,
};
